exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".birth-bar {\n  fill: #6dc066;\n  opacity: 0.5;\n}\n.death-bar {\n  fill: #f30f3c;\n  opacity: 0.5;\n}\n.year-label-border {\n  fill: #fff;\n  stroke: #666;\n  stroke-width: 0.5px;\n}\n.year-label-text {\n  font-weight: 400;\n  font-size: 11px;\n  font-family: sans-serif;\n  fill: black;\n}\n.timeline__headline {\n  text-transform: uppercase;\n  text-align: left;\n  padding: 0 1em;\n  padding-top: 2px;\n  color: #888;\n}\n.timeline-headline--green {\n  color: #6dc066;\n}\n.timeline-headline--red {\n  color: #f30f3c;\n}\n", ""]);

// exports
